import { Injectable, inject } from '@angular/core';
import { KeyValueChildrenModel } from '@models/common';
import { HttpService } from '@shared/services';

@Injectable({ providedIn: 'root' })
export class ReorderRelationsService {
  http = inject(HttpService);

  get() {
    return this.http.get<KeyValueChildrenModel<number, string>[]>('_api/ModuleRelation/PaymentRelations', {
      useLoader: false,
    });
  }

  save(relations: KeyValueChildrenModel<number, string>[]) {
    return this.http.put('_api/ModuleRelation/SavePaymentRelationsOrder', relations, {
      useLoader: false,
    });
  }
}
